import {
  FileResp,
  CheckData,
} from "@/components/form-multiple-import/form-multiple-import.interface";
import { HttpService } from "@/core";
import { ExportBtnResp } from "../export-btn/export-btn.interface";

export class FormMultipleImportService {
  static useGetExcelData() {
    const api = (apiUrl, url) =>
      HttpService.axios({
        url: `${apiUrl}${apiUrl.indexOf("?") > -1 ? "&&" : "?"}url=${url}`,
        data: {
          url,
        },
        method: "post",
      });
    return HttpService.useRequest<FileResp<any>>(api);
  }

  static useGetCheckData() {
    const api = (key) =>
      HttpService.axios({
        url: `/common_api/getImportCheckResult/${key}`,
        method: "get",
      });
    return HttpService.useRequest<CheckData>(api);
  }

  static useExportExcelData() {
    const api = (key, type) =>
      HttpService.axios({
        url: `/async/import/new/commonMargeExport`,
        data: {
          key,
          type,
        },
        method: "post",
      });
    return HttpService.useRequest<ExportBtnResp>(api, { isOutError: true });
  }
}
